import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import SearchField from '../../../../components/atoms/formFields/inputField/searchField';
import SelectOption from '../../../../components/atoms/formFields/selectOption';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllBrands } from '../../../../store/thunks/brandThunk';
import { GetAllProductDomains, GetParentByDomain } from '../../../../store/thunks/sellerProductCategoriesThunk';

const CommonSearch = ({ filters, setFilters }) => {
    const dispatch = useDispatch();
    const { data: brands } = useSelector(state => state?.allBrands);
    const { data: domains } = useSelector(state => state?.allProductDomains);
    const { data: parents } = useSelector(state => state?.parentByDomain);

    useEffect(() => {
        dispatch(GetAllBrands());
        dispatch(GetAllProductDomains());
    }, []);

    const handleSetFilters = (key, value, extra = {}) => {
        setFilters({
            paginationFilter: { offset: 0, limit: 10, order: "DESC" },
            ...filters,
            ...extra,
            [key]: value || "",
        });
    };

    const getOptions = (data, labelKey = 'name.en', valueKey = 'key') =>
        data?.map(item => ({
            label: labelKey.split('.').reduce((o, k) => o?.[k], item),
            value: item?.[valueKey]
        })) || [];

    const renderOrLabel = (key) => (
        <Col xs={24} lg={1} className="text-center">
            <label className="d-block text-center mb-5">&nbsp;</label>
            <span className="font-weight-bolder label label-primary letter-spacing m-0 m-auto p-5">
                {key}
            </span>
        </Col>
    );

    return (
        <div className="common-search mb-10">
            <Row gutter={[12, 12]}>
                <Col xs={24} lg={5}>
                    <div className="mt-2">
                        <SearchField
                            placeholder="Search..."
                            name="By Product Name"
                            onChange={(e) => handleSetFilters("text", e.target.value)}
                        />
                    </div>
                </Col>

                {renderOrLabel("OR")}

                <Col xs={24} lg={5}>
                    <div className="mt-2">
                        <SelectOption
                            name="By Brand Name"
                            placeholder="Select Brand Name"
                            isClearable
                            options={getOptions(brands)}
                            onChange={(e) => handleSetFilters("companyId", e?.value)}
                        />
                    </div>
                </Col>

                {renderOrLabel("OR")}

                <Col xs={24} lg={5}>
                    <div className="mt-2">
                        <SelectOption
                            name="By Category"
                            placeholder="Select Domain Category"
                            isClearable
                            options={getOptions(domains, 'name.en', 'id')}
                            onChange={(val) => {
                                handleSetFilters("productDomainId", val?.value);
                                dispatch(GetParentByDomain({ id: val?.value }));
                            }}
                        />
                    </div>
                </Col>

                <Col xs={24} lg={5}>
                    <div className="mt-2">
                        <SelectOption
                            name="Parent Category"
                            placeholder="Select Parent Category"
                            isClearable
                            options={getOptions(parents, 'name.en', 'id')}
                            onChange={(val) =>
                                handleSetFilters("productParentCategoryId", val?.value, {
                                    productDomainId: filters?.productDomainId || "",
                                })
                            }
                        />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default CommonSearch;